import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  user: any;

  constructor(private router: Router) {}

  ngOnInit() {
    // Parse the user from localStorage
    const userData = localStorage.getItem('user');
    if (userData) {
      this.user = JSON.parse(userData); // Convert back to object
    }
  }

  // Log out the user and clear localStorage
  logoutUser() {
    localStorage.clear();
    this.router.navigateByUrl('auth/register');
  }
}
